/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { GetYoutubeIntegrationStatsSelfViewersQueryResponse, GetYoutubeIntegrationStatsSelfViewersPathParams, GetYoutubeIntegrationStatsSelfViewersQueryParams } from "../models/GetYoutubeIntegrationStatsSelfViewers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getYoutubeIntegrationStatsSelfViewers } from "../axios/getYoutubeIntegrationStatsSelfViewers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getYoutubeIntegrationStatsSelfViewersQueryKey = (station: GetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: GetYoutubeIntegrationStatsSelfViewersQueryParams) => ["web-app-bff-api", { url: '/youtube-stats/viewers/:station/self', params: {station:station} }, ...(params ? [params] : [])] as const

export type GetYoutubeIntegrationStatsSelfViewersQueryKey = ReturnType<typeof getYoutubeIntegrationStatsSelfViewersQueryKey>

export function getYoutubeIntegrationStatsSelfViewersQueryOptions(station: GetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: GetYoutubeIntegrationStatsSelfViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getYoutubeIntegrationStatsSelfViewersQueryKey(station, params)
        return queryOptions<GetYoutubeIntegrationStatsSelfViewersQueryResponse, ResponseErrorConfig<Error>, GetYoutubeIntegrationStatsSelfViewersQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return getYoutubeIntegrationStatsSelfViewers(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Uses the station `youtubeChannelId`. Responds with 400 when it is not set, and 404 when the channel is not in the live-viewers catalog.
 * @summary Viewer time series for the station YouTube channel
 * {@link /youtube-stats/viewers/:station/self}
 */
export function useGetYoutubeIntegrationStatsSelfViewers<TData = GetYoutubeIntegrationStatsSelfViewersQueryResponse, TQueryData = GetYoutubeIntegrationStatsSelfViewersQueryResponse, TQueryKey extends QueryKey = GetYoutubeIntegrationStatsSelfViewersQueryKey>(station: GetYoutubeIntegrationStatsSelfViewersPathParams["station"], params: GetYoutubeIntegrationStatsSelfViewersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetYoutubeIntegrationStatsSelfViewersQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? getYoutubeIntegrationStatsSelfViewersQueryKey(station, params)
         

         const query = useQuery({
          ...getYoutubeIntegrationStatsSelfViewersQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}